"use client";
import { GET_COURSES } from "@/app/env";
import { CousrsListItemType } from "@/app/types";
import { useLocale, useTranslations } from "next-intl";
import { Link } from "@/app/config/navigation";
import React, { useEffect, useMemo, useState } from "react";
import { sortArrayBySequence } from "@/app/utils/sorting";

export function Menu({ menuOnClick }: { menuOnClick?: () => void }) {
  const locale = useLocale();

  const [courses, setCourses] = useState<CousrsListItemType[]>([]);
  useEffect(() => {
    const getData = async () => {
      const data = await fetch(`${GET_COURSES}?Lang=${locale}`, {
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
      });
      setCourses(await data.json());
    };
    getData();
  }, [locale]);
  const t = useTranslations("layout");

  const filterCourses = useMemo(
    () => courses?.filter((course) => course.isActive),
    [courses]
  );
  const sortedCourses = useMemo(
    () => sortArrayBySequence(filterCourses),
    [filterCourses]
  );
  const fullMenu = [
    {
      title: t("courses"),
      className: "bg-orange",
      list: [
        ...sortedCourses?.slice(0, 4)?.map((course) => ({
          title: course.name,
          link: `/courses/${course.slug || (course.name ? course.name.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '') : course.id)}`,
        })),

        {
          title: t("see_all"),
          link: "/courses",
        },
      ],
    },
    {
      title: t("outcomes"),
      className: "bg-orangeLight",

      list: [
        {
          title: t("ourGraduates"),
          link: "/graduates",
        },
        {
          title: t("studentsProjects"),
          link: "/projects",
        },
        {
          title: t("testimonials"),
          link: "/#testimonials",
        },
      ],
    },
    // {
    //   title: t("blog"),
    //   className: "bg-blue-400",
    //   list: [
    //     {
    //       title: t("blog"),
    //       link: "/blog",
    //     },
    //   ],
    // },
    {
      title: t("aboutAs"),
      className: "bg-green",

      list: [
        {
          title: t("ourStory"),
          link: "/about-us",
        },
        {
          title: t("ourTeam"),
          link: "/about-us/#team",
        },
        {
          title: t("whyUs?"),
          link: "/#why-us",
        },
        {
          title: t("blog"),
          link: `/blog`,
        },
      ],
    },

    {
      title: t("pricing"),
      className: "bg-secondary",

      list: [
        {
          title: t("vIPCourses"),
          link: "/vip",
        },
        {
          title: t("familyDiscount"),
          link: "/family-discount",
        },
        {
          title: t("giveGift"),
          link: "/give-gift",
          className:
            "border-t-2 border-[#41365A] mt-[10px] pt-[10px] inline-block",
        },
      ],
    },
  ];
  return (
    <div className=" grid container lg:mt-[9.6rem]   text-fontLight  md:grid-cols-4 grid-cols-2 col-span-full  md:grid-rows-1	w-max grid-rows-2 px-[21px] lg:pl-[8rem] lg:pr-[18rem]  justify-center gap-[5rem] md:gap-20	 lg:gap-20 text-3xl">
      {fullMenu.map((item) => (
        <section
          key={item.title}
          className="col-span-1  -mr-[10px]  max-w-[136px]	lg:max-w-[265px]   flex flex-col  "
        >
          <h2 className="font-semibold text-[13px] rtl:max-md:leading-[30px] xsm:text-[18px]  md:text-[25px] lg:text-[2.25rem] relative mb-8 uppercase">
            <span
              className={`w-[10px] h-[10px] lg:w-[0.96rem] lg:h-[0.96rem] rounded-full translate-y-[-50%] ${item.className} absolute top-1/2 start-[-21px]`}
            ></span>
            {item.title}
          </h2>

          <div>
            {item.list.map((item, index) => (
              <Link
                onClick={menuOnClick}
                key={index}
                className={`text-[11px] mb-2 block xs:text-[14px] md:text-[17px] lg:text-[1.3rem] font-[300] text-fontLight ${item.className}`}
                href={item.link}
              >
                {item.title}
              </Link>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}
